<template>
    <div class="sponsors-row" v-if="sponsors.length">
        <div
            v-for="(sps, index) in sponsors"
            :key="index"
            class="sponsor-slide"
        >
            <a :href="sps.href" class="sponsors__link" target="_blank" rel="noopener">
                <img
                    :src="localizedAsset(sps.img_path)"
                    :alt="sps.name"
                    class="sponsors__image"
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sponsorsArr: {
            type: Array
        }
    },
    name: "sponsors-slider",
    data() {
        return {
            sponsors: []
        };
    },
    methods: {
        loadSponsors() {
            axios.post("/get-sponsors").then((res) => {
                this.sponsors = res.data;
            });
        },
        localizedAsset(path) {
            const base = window.APP_URL.replace(/\/+$/, '');
            const formattedPath = path.replace(/^\/+/, '');
            return `${base}/${formattedPath}`;
        }
    },
    mounted() {
        this.loadSponsors();
    }
};
</script>

<style scoped>
.sponsors-row {
    display: flex;
    flex-wrap: wrap; /* allows wrapping on smaller screens */
    justify-content: center;
    gap: 100px; /* space between each sponsor */
    padding: 30px 20px;
}

.sponsor-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

.sponsors__link {
    display: block;
    max-width: 180px;
    text-align: center;
}

.sponsors__image {
    max-height: 185px;
    max-width: 100%;
    object-fit: contain;
    border-radius: 10px;
}
</style>
